/**
 * InspectionAcceptance model translations
 *
 * Translation keys follow the pattern: models.inspection-acceptance.{category}.{key}
 * Categories: fields, tabs, blocks, badges, filters
 */
export default {
  en: {
    singular: "Inspection Acceptance",
    plural: "Inspection Acceptances",

    tabs: {
      general: "General",
    },

    blocks: {
      acceptance: "Acceptance Details",
    },

    fields: {
      user_id: "Recipient",
      inspection_id: "Inspection",
      viewed_at: "Viewed At",
      accepted_at: "Accepted At",
      created_at: "Sent At",
      user: {
        full_name: "Recipient",
      },
      inspection: {
        client: {
          name: "Client",
        },
      },
    },

    badges: {},

    filters: {
      inspection_id: "Inspection",
    },
  },

  fr: {
    singular: "Acceptation d'inspection",
    plural: "Acceptations d'inspection",

    tabs: {
      general: "Général",
    },

    blocks: {
      acceptance: "Détails de l'acceptation",
    },

    fields: {
      user_id: "Destinataire",
      inspection_id: "Inspection",
      viewed_at: "Consulté le",
      accepted_at: "Accepté le",
      created_at: "Envoyé le",
      user: {
        full_name: "Destinataire",
      },
      inspection: {
        client: {
          name: "Client",
        },
      },
    },

    badges: {},

    filters: {
      inspection_id: "Inspection",
    },
  },
};
